<app-store-navigation></app-store-navigation>
@if (employeeDetails) {
  <div>
    <h2 class="employee-name">{{ employeeDetails.employee.name }}</h2>
    <p class="employee-current-role">{{ employeeDetails.employee.role | enumParse }}</p>
    @if (employeeDetails.employee.availableFrom?.isAfter(today)) {
      <div>Employee contract starts
      on {{ employeeDetails.employee.availableFrom | dateFormat: 'ddd, D MMM YYYY' }}</div>
    }
    @if (employeeDetails.employee.deletedFrom) {
      <div>Employee contract ends
      on {{ employeeDetails.employee.deletedFrom | dateFormat: 'ddd, D MMM YYYY' }}</div>
    }
    @if (employeeDetails.employee.hasManagerRole()) {
      <div class="row">
        <app-manager-settings
          class="manager-settings"
          [employeePositionId]="employeeDetails.employee.employeePositionId"
          [managerSettings]="employeeDetails.managerSettings"
          (getEmployeePageDataEvent)="getData()">
        </app-manager-settings>
      </div>
    }
    <div class="row">
      <app-capabilities
        class="col capabilities"
        [employeePositionId]="employeeDetails.employee.employeePositionId"
        [capabilities]="employeeDetails.capabilities"
        (getEmployeePageDataEvent)="getData()">
      </app-capabilities>
      <app-employee-rank
        class="col ms-2 employee-rank"
        [employeePositionId]="employeeDetails.employee.employeePositionId"
        [employeeRanks]="employeeDetails.employeeRanks"
        (getEmployeePageDataEvent)="getData()">
      </app-employee-rank>
    </div>
    <div class="row">
      <app-contract-hours class="col contract-hours"
      [contractHours]="employeeDetails.contractHours"></app-contract-hours>
      <app-maximum-working-hours class="col ms-2 maximum-working"
        [employeePositionId]="employeeDetails.employee.employeePositionId"
        [contractHours]="employeeDetails.employee.contractHours"
        [maximumWorkingHours]="employeeDetails.maximumWorkingHours"
        (getEmployeePageDataEvent)="getData()">
      </app-maximum-working-hours>
    </div>
    <div class="row">
      <app-availability
        class="col availability"
        [employeePositionId]="employeeDetails.employee.employeePositionId"
        [storeDetails]="storeDetails"
        [data]="employeeDetails.availabilities"
        (getEmployeePageDataEvent)="getData()">
      </app-availability>
    </div>
    <div class="row">
      <app-preferred-time-off
        class="col mb-3 preferred-day-off"
        [employeePositionId]="employeeDetails.employee.employeePositionId"
        [storeDetails]="storeDetails"
        [preferredTimesOff]="employeeDetails.preferredTimesOff"
        [temporaryPreferredTimesOff]="employeeDetails.temporaryPreferredTimesOff"
        (getEmployeePageDataEvent)="getData()">
      </app-preferred-time-off>
    </div>
  </div>
}
